import type { enBarcelona } from './en.barcelona';

/** Fase F (paquete barcelona): Barcelona, el único viaje al extranjero. Las frases entre “comillas” son práctica de inglés y se quedan en inglés. */
export const esBarcelona: typeof enBarcelona = {
  barcelona: {
    mapNames: { barcelona: 'Barcelona' },
    zones: {
      bc_city: 'Barcelona',
      bc_airport: 'Aeropuerto de El Prat · llegadas',
      bc_guell: 'Park Güell',
      bc_sagrada: 'Sagrada Família y el Eixample',
      bc_rambla: 'La Rambla',
      bc_gotic: 'Barri Gòtic',
      bc_park: 'Parque de la Ciutadella',
      bc_beach: 'Port Vell y la Barceloneta',
    },
    objects: {
      bc_flight: 'Vuelo de vuelta · El Prat',
      bc_aerobus: 'Parada del Aerobús (a Plaça Catalunya)',
      bc_metroGuell: 'Metro L3 · Lesseps',
      bc_metroSagrada: 'Metro L5 · Sagrada Família',
      bc_metroLiceu: 'Metro L3 · Liceu',
      bc_metroBeach: 'Metro L4 · Barceloneta',
      bc_guellBench: 'Banco ondulado',
      bc_dragon: 'El dragón (el drac)',
      bc_sagrada: 'Sagrada Família',
      bc_canaletes: 'Fuente de Canaletes',
      bc_flowers: 'Quiosco de flores',
      bc_statue: 'Estatua humana',
      bc_boqueria: 'Mercado de la Boqueria',
      bc_columbus: 'Monumento a Colón',
      bc_cathedral: 'Catedral de Santa Eulàlia',
      bc_xurros: 'Puesto de churros con chocolate',
      bc_castellers: 'Castellers (torre humana)',
      bc_petanca: 'Pista de petanca',
      bc_chiringuito: 'Chiringuito de playa',
    },
    npc: {
      bc_florist: 'Vendedora de flores',
      bc_guide: 'Guía de la Sagrada Família',
      bc_waiter: 'Camarero del chiringuito',
      bc_avi: 'Abuelo con el pan',
      bc_tourist: 'Turista taiwanés perdido',
      bc_busker: 'Guitarrista callejero',
      bc_sardanista: 'Bailarina de sardana',
      bc_petancaMan: 'Jugador de petanca',
      bc_juicer: 'Vendedor de zumos',
      bc_kid: 'Niña con patines',
      bc_staff: 'Información del aeropuerto',
      bc_casteller: 'Cap de colla',
      bc_painter: 'Retratista',
    },
    items: {},

    metro: {
      text: 'Metro de Barcelona. ¿Qué parada?',
      guell: '🟢 L3 · Lesseps (Park Güell)',
      sagrada: '🔵 L5 · Sagrada Família',
      liceu: '🟢 L3 · Liceu (La Rambla)',
      beach: '🟡 L4 · Barceloneta (playa)',
      airport: '🟠 L9 · Aeropuerto T1',
      riding: '🚇 Las puertas se cierran con un silbido… y en marcha.',
      fact: 'El metro de Barcelona abrió en 1924, uno de los más antiguos de España. Con una T-casual tienes diez viajes.',
    },
    aerobus: {
      text: 'El Aerobús A1 va de la T1 a Plaça Catalunya cada cinco minutos: unos 35 minutos hasta el centro.',
      go: '🚌 Ir a Plaça Catalunya',
      riding: 'El autobús azul entra en la autopista… Montjuïc a la izquierda… ¡Plaça Catalunya!',
      arrived: 'Plaça Catalunya: las palomas, las fuentes, y La Rambla empieza justo aquí y baja hasta el mar.',
    },

    sagrada: {
      text: 'La Sagrada Família: la basílica de Antoni Gaudí. Las obras empezaron en 1882 y TODAVÍA no han terminado: las grúas forman parte del paisaje. Cuando esté acabada tendrá 18 torres.',
      ask: '🗣️ Preguntar al guía (inglés)',
      q: '¿Cómo le preguntas al guía cuándo estará acabada la basílica?',
      a: ['Excuse me, when will the basilica be finished?', 'Finish when basilica?', 'Basilica done now, yes?'],
      right: '“Good question! The tallest tower, for Jesus, should be ready soon — 172 metres, taller than any other church in the world.”',
      wrong: 'El guía sonríe: “Try again — start with ‘Excuse me…’”',
      phrase: 'Excuse me, when will the basilica be finished?',
    },
    guellBench: {
      text: 'El banco ondulado de la plaza del Park Güell: 110 metros de curvas cubiertas de trencadís, trozos de azulejo roto pegados formando mosaicos. Desde aquí se ve toda la ciudad hasta el mar.',
      sit: '🪑 Sentarse a mirar la ciudad',
      sat: 'Azul, amarillo, blanco… cada azulejo tiene una forma distinta. Abajo asoman las torres de la Sagrada Família por encima de los tejados.',
      phrase: 'What a beautiful view!',
      q: '¿Qué es el “trencadís”?',
      a: ['Un mosaico hecho con azulejos rotos', 'Un tipo de pan catalán', 'Un banco de madera muy largo'],
      right: '¡Exacto! Gaudí usaba los azulejos que las fábricas tiraban. Nada se desperdicia.',
      wrong: 'Mira el banco: está hecho de miles de trocitos rotos…',
    },
    dragon: {
      text: 'El drac: la salamandra de mosaico de la escalinata, el animal más fotografiado de Barcelona. De su boca cae agua a la pila.',
      photo: '📸 Hacer la foto',
      done: '¡Clic! Los demás esperan su turno… En Taiwán también hay muchos dragones, pero este está cubierto de azulejos.',
      q: 'El dragón en realidad es…',
      a: ['Una salamandra', 'Un cocodrilo', 'Un gato'],
      right: '¡Una salamandra! A Gaudí le encantaban los animales y los puso por todo el parque.',
      wrong: 'Fíjate en sus patas cortas y su cola larga…',
    },
    canaletes: {
      text: 'La fuente de Canaletes, en lo alto de La Rambla. Dicen que quien bebe de ella vuelve a Barcelona. Los aficionados del Barça celebran aquí sus victorias.',
      drink: '🚰 Beber agua',
      drank: '¡Fría y fresca! Ahora tendrás que volver algún día.',
      phrase: 'I will come back to Barcelona!',
    },
    statue: {
      text: 'Una estatua humana: un hombre pintado de bronce, quieto del todo, haciendo de Colón. Echa una moneda y… algo pasa.',
      tip: '🪙 Echar una moneda (2 monedas)',
      moved: 'La estatua parpadea, hace una reverencia y señala el mar con un crujido. ¡Y se vuelve a quedar quieta!',
      poor: 'Hoy no hay monedas para la estatua.',
    },
    columbus: {
      text: 'El monumento a Colón, de 60 metros, al final de La Rambla. Se construyó para la Exposición Universal de 1888. Colón señala al mar… hacia el este, ¡que ni siquiera es donde está América!',
      look: '🔭 Mirar adónde señala',
      q: '¿A qué mar señala Colón?',
      a: ['Al Mediterráneo', 'Al Pacífico', 'Al Atlántico'],
      right: '¡Sí! Barcelona está en el mar Mediterráneo. Taiwán está en el Pacífico.',
      wrong: 'Mmm… el mar de Barcelona es cálido, azul y sin grandes olas. ¿Cuál es?',
    },
    cathedral: {
      text: 'La catedral de Santa Eulàlia, construida entre 1298 y 1420. En su claustro viven trece ocas blancas, una por cada año de la corta vida de la santa.',
      geese: '🪿 Contar las ocas',
      q: '¿Cuántas ocas viven en el claustro?',
      a: ['Trece', 'Tres', 'Treinta'],
      right: 'Trece, como los años de Eulàlia. Y los domingos se baila la sardana aquí mismo.',
      wrong: 'Tantas como años vivió la santa: era muy joven…',
    },
    castellers: {
      text: 'Los castellers levantan torres humanas de hasta diez pisos. La base es la “pinya”; el niño o niña que sube arriba del todo es la “enxaneta” y levanta la mano cuando la torre está completa.',
      cheer: '📣 Animar a la enxaneta',
      cheered: 'La plaza se calla… la enxaneta levanta la mano… “Castell carregat!” Todo el mundo aplaude. Luego bajan con el mismo cuidado.',
      q: 'El lema de los castellers es “Força, equilibri, valor i seny”. ¿Qué significa “seny”?',
      a: ['Sensatez', 'Ruido', 'Velocidad'],
      right: 'Sensatez: ir con cuidado y con calma. Hacen falta las cuatro cosas para levantar una torre.',
      wrong: 'Piensa: ¿qué hace falta para que nadie se caiga? Fuerza, equilibrio, valor… y…',
    },
    petanca: {
      text: 'Petanca: lanza la bola de acero lo más cerca posible del “boliche” de madera. Los abuelos juegan aquí todas las tardes.',
      throw: '🎯 Lanzar una bola',
      result: (cm: number) => `Tu bola se para a ${cm} cm del boliche.`,
      great: '¡La más cercana de todas! Los abuelos asienten: “molt bé”.',
      again: '🎯 Lanzar otra vez',
    },

    flowers: {
      vendor: 'Hello! Roses, tulips, sunflowers — what would you like?',
      ok: 'One sunflower, please.',
      bad: ['Give flower.', 'Sunflower me want.'],
      done: '🌻 Un girasol envuelto en papel. Todo el mundo sonríe al verlo bajar por La Rambla.',
      price: 6,
    },
    boqueria: {
      text: 'La Boqueria: el mercado de Sant Josep, desde 1840. Vasos de zumo de todos los colores, jamón, fruta, pescado… Aquí los mercados abren por la mañana y cierran por la tarde.',
      closed: 'La Boqueria está cerrada. Los mercados de Barcelona abren temprano y cierran por la tarde, ¡al revés que los mercados nocturnos de Taiwán!',
      juice: { vendor: 'Juices! Mango, strawberry, coconut, dragon fruit… which one?', ok: 'A mango juice, please.', bad: ['Mango juice now.', 'Juice of mango give.'], done: '🥭 Zumo de mango helado en vaso de papel. Un sorbo y se va el calor de La Rambla.', price: 4 },
      ham: { vendor: 'Jamón ibérico, cut thin — a paper cone for you?', ok: 'A cone of jamón, please.', bad: ['Jamón cone me.', 'Want jamón, cone.'], done: '🍖 Un cucurucho de jamón, salado y tierno. En España se corta a mano, loncha a loncha.', price: 8 },
      fruit: { vendor: 'Fresh fruit cups — melon, kiwi, strawberries!', ok: 'A fruit cup, please.', bad: ['Fruit cup, now!', 'Cup fruit I take.'], done: '🍓 Un vaso de fruta cortada con un tenedorcito de madera. ¡Dulce!', price: 5 },
    },
    xurros: {
      vendor: 'Churros with thick hot chocolate — breakfast or afternoon snack?',
      ok: 'Churros with chocolate, please.',
      bad: ['Churros chocolate give.', 'Me churros now.'],
      done: '🍫 Churros crujientes mojados en un chocolate tan espeso que la cuchara se queda de pie. Aquí se desayunan… ¡o se toman al amanecer después de una fiesta!',
      price: 6,
    },
    chiringuito: {
      text: 'Un chiringuito en la arena: paella, crema catalana, horchata fría. En España se come a las dos o las tres y se cena a las nueve, ¡mucho más tarde que en Taiwán!',
      noPaella: 'El camarero: “Paella? Not yet — lunch here starts at two! Horchata or a crema catalana while you wait?”',
      paella: { vendor: 'Paella for one? Rice, prawns, mussels, a slice of lemon.', ok: 'A paella, please.', bad: ['Paella me.', 'Give paella now.'], done: '🥘 Arroz amarillo con gambas y limón, con el mar delante. Lo mejor es la costra del fondo: el “socarrat”.', price: 18 },
      crema: { vendor: 'Crema catalana: custard with burnt sugar on top. Crack it with the spoon!', ok: 'A crema catalana, please.', bad: ['Crema give.', 'Catalana crema now.'], done: '🍮 ¡Crac! El azúcar se rompe como el cristal, y debajo está frío y cremoso.', price: 6 },
      horchata: { vendor: 'Cold horchata — made from tiger nuts, very sweet.', ok: 'A horchata, please.', bad: ['Horchata me want.', 'Give horchata.'], done: '🥛 Dulce, fría y lechosa. ¡Nada que ver con la leche de soja de casa!', price: 4 },
    },

    talk: {
      bc_florist: [
        '¡Flores en La Rambla desde 1850! Por Sant Jordi, el 23 de abril, todo el mundo regala una rosa y un libro. “A rose for you!”',
        'Los tulipanes vienen de Holanda; las rosas, de aquí. “Which one do you like?”',
      ],
      bc_guide: [
        'Gaudí decía: “La naturaleza es mi maestra”. Mira las columnas de dentro: se ramifican como árboles. “Welcome to the Sagrada Família!”',
        'Gaudí trabajó aquí 43 años y está enterrado en la cripta. Las obras se pagan con las entradas, sin dinero del gobierno.',
      ],
      bc_waiter: [
        '¿Comer? Antes de las dos, no; aquí lo hacemos así. ¡Y cenar a las nueve o las diez! “Are you hungry?”',
        'Aquí pagamos en euros, no en dólares taiwaneses. Un euro son unos 35 dólares de Taiwán, así que una paella son… ¡muchos dólares! “The bill, please.”',
      ],
      bc_avi: [
        'Cada mañana: una barra del horno y un café. Pa amb tomàquet: pan frotado con tomate, aceite y sal. ¡Pruébalo! “Good morning!”',
        'Cuando yo era niño pagábamos en pesetas. Luego llegó el euro en 2002. ¡Ahora lo cuento todo dos veces!',
      ],
      bc_busker: [
        '♪ Rumba catalana, la música de las calles del Gòtic. Una moneda en el sombrero y te toco tu canción. “Thank you, my friend!”',
        'Aprendí con esta guitarra de mi abuelo. La plaza tiene el mejor eco de Barcelona.',
      ],
      bc_sardanista: [
        'La sardana: nos damos las manos en círculo y contamos los pasos, cortos y largos. Cualquiera puede entrar, ¡tú también! “Come and dance!”',
        'La banda se llama cobla. La flauta aguda es el flabiol: el músico la toca con una mano y un tamboril con la otra.',
      ],
      bc_petancaMan: [
        'Cada tarde, el mismo banco, los mismos amigos, las mismas bolas. El secreto está en la muñeca. “Your turn!”',
        'La petanca viene del sur de Francia, pero aquí llevamos cien años jugando.',
      ],
      bc_juicer: [
        'Dos euros el vaso, tres el grande. Abrimos a las ocho y cerramos a las tres: ¡luego nos vamos a comer a casa! “Fresh juice!”',
        'Pitahaya, mango, piña, coco… los colores se venden solos.',
      ],
      bc_kid: [
        '¡Patino todo el paseo, del hotel W al puerto, en doce minutos! “Catch me if you can!”',
        'En verano el agua está caliente hasta octubre. ¿Hoy? Un poco fría, pero mi padre dice que soy de goma.',
      ],
      bc_staff: [
        '¡Bienvenido a Barcelona! Aerobús al centro cada cinco minutos, o el metro L9. “Can I help you?”',
        '¿Vuelves a casa? Los vuelos internacionales salen de la T1: pasa el control pronto, el aeropuerto de Barcelona es grande.',
      ],
      bc_casteller: [
        'Soy el cap de colla: decido qué torre hacemos. Hoy, un cuatro de ocho. Ocho pisos, cuatro personas en cada uno. “Up we go!”',
        'Los más fuertes van abajo, en la pinya, y el niño más ligero arriba. Cada uno tiene su trabajo.',
      ],
      bc_painter: [
        'Un retrato en diez minutos, a carboncillo o pastel. He dibujado turistas de cuarenta países… y uno de Taiwán: ¿tú? “Sit down, please!”',
        'Lo difícil es la sonrisa. Todo el mundo deja de sonreír a los tres minutos.',
      ],
    },
    tourist: {
      intro: '你好！請問，聖家堂怎麼走？我迷路了…\n\n(¡Hola! Perdona, ¿cómo se va a la Sagrada Família? Me he perdido…)',
      help: '🗣️ Ayudarle en chino',
      q: '怎麼回答他？ (¿Cómo le contestas?)',
      a: ['坐地鐵 L5 藍線，到 Sagrada Família 站下車。 (Coge el metro azul L5 hasta Sagrada Família.)', '一直走到海邊。 (Sigue andando hasta el mar.)', '坐飛機回台灣。 (Coge un avión de vuelta a Taiwán.)'],
      right: '「太好了，謝謝你！」Hace dos reverencias, aliviadísimo, y te regala un pastel de piña de su bolsa. 🍍',
      wrong: '「海邊？」Mira el mapa, confundido. La basílica está al norte, junto al metro…',
    },
    hours: 'En Barcelona se come a las 14 h y se cena a las 21 h. Las tiendas cierran a mediodía un buen rato y el mercado cierra por la tarde.',
  },
};
